// src/components/Home.js
import React from "react";
import main from "../../../assets/ft-workspace.webp";
import { Grid2, Box } from "@mui/material";
import reminder_ic from "../../../assets/carbon_reminder.png";
import deadline_ic from "../../../assets/deadline-sort.svg";
import track_ic from "../../../assets/track-changes.svg";
import assign_ic from "../../../assets/assignment-add-outline.svg";
import { blue, amber } from "@mui/material/colors";

const WorkspaceItem = () => {
    const features = [
        {
            icon: assign_ic,
            title: "Real-Time Disussions",
            description:
                "Engage in conversations with team members",
            color: blue[700],
        },
        {
            icon: track_ic,
            title: "Task and File Sharing",
            description:
                "Share documents and assign tasks seamlesslyShare documents and assign tasks seamlessly",
            color: amber[600],
        },
        {
            icon: deadline_ic,
            title: "Notifications and Mentions",
            description:
                "Stay updated with instant alerts for relevant activities",
            color: amber[600],
        },
    ];

    return <section id="features">
        <div className="container-top-2">
            <h1 className="h1-48-600">
                <span>Collaborative </span>
                Workspace
            </h1>
            <p className="ft-para">
                Empower teams to communicate and collaborate seamlessly
            </p>
            {/* <button className="outlined-button-type2"
                type='button'
                onClick={(e) => { }}>
                Request Demo
            </button> */}
        </div>

        <div className="container-ft-images">
            <div className="main-image-wrapper">
                <img
                    src={main}
                    alt="Main"
                    className="main-image"
                />
                {/* <img
                    src={secondary}
                    alt="Small"
                    className="small-image"
                /> */}
            </div>
        </div>

        <div className="container-top">
            <h1 className="h1-48-600">
                Key <span>Benefits</span>
            </h1>
            <p className="ft-para">
                Why Choose Our Task & Plan Management? Boost Efficiency, Reduce Delays, and Stay on Track
            </p>
        </div>
        <div className="grid-container space1">
            <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {features.map((feature, index) => (
                    <Grid2 key={index} size={{ xs: 12, sm: 12, md: 6 }} className="grid-item">
                        <div className="feature-item">
                            <div className="feature-top">
                                <Box
                                    sx={{
                                        width: { xs: 24, sm: 30, md: 48, lg: 52 },
                                        height: { xs: 24, sm: 30, md: 48, lg: 52 },
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "8px",
                                        bgcolor: feature.color,
                                        margin: "4px",
                                        borderRadius: "20px",
                                    }}
                                >
                                    <img
                                        src={feature.icon}
                                        alt="Feature icon"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }} />
                                </Box>
                                <p className="feature-item-title">
                                    {feature.title}
                                </p>
                            </div>
                            <div className="feature-content">
                                <p className="feature-item-text">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    </Grid2>
                ))}
            </Grid2>
        </div>
    </section>;
};
export default WorkspaceItem;
